import React, {PureComponent} from 'react';

import Input from '../../components/Input';

import SubConfiguration from './SubConfiguration';

const TEXT_DEFAULT_ANSWER_TYPES = {
  SUBMITTER_USERNAME: '{{SUBMITTER_USERNAME}}',
  SUBMITTER_EMAIL: '{{SUBMITTER_EMAIL}}',
  CUSTOM: 'CUSTOM',
};

function getTextDefaultAnswerType(value) {
  if (value === TEXT_DEFAULT_ANSWER_TYPES.SUBMITTER_USERNAME) return 'SUBMITTER_USERNAME';
  if (value === TEXT_DEFAULT_ANSWER_TYPES.SUBMITTER_EMAIL) return 'SUBMITTER_EMAIL';
  if (value) return 'CUSTOM';
  return '';
}

class DefaultAnswers extends PureComponent {
  constructor(props) {
    super(props);

    const defaultAnswers = props.question.defaultAnswers || [];
    const currentValue = defaultAnswers[0] || '';
    const answerType = getTextDefaultAnswerType(currentValue);

    this.state = {
      textDefaultType: answerType,
      customTextValue: answerType === 'CUSTOM' ? currentValue : '',
    };
  }

  componentDidUpdate(prevProps) {
    const prevDefaults = prevProps.question.defaultAnswers || [];
    const currentDefaults = this.props.question.defaultAnswers || [];
    const prevValue = prevDefaults[0] || '';
    const currentValue = currentDefaults[0] || '';

    if (prevValue !== currentValue) {
      const answerType = getTextDefaultAnswerType(currentValue);
      this.setState({
        textDefaultType: answerType,
        customTextValue: answerType === 'CUSTOM' ? currentValue : '',
      });
    }
  }

  handleTextTypeChange = (e) => {
    const type = e.target.value;
    const {onChange} = this.props;

    this.setState({textDefaultType: type});

    if (type === 'SUBMITTER_USERNAME') {
      onChange([TEXT_DEFAULT_ANSWER_TYPES.SUBMITTER_USERNAME]);
    } else if (type === 'SUBMITTER_EMAIL') {
      onChange([TEXT_DEFAULT_ANSWER_TYPES.SUBMITTER_EMAIL]);
    } else if (type === 'CUSTOM') {
      onChange([this.state.customTextValue]);
    } else {
      onChange([]);
    }
  };

  handleCustomTextChange = (e) => {
    const value = e.target.value;
    this.setState({customTextValue: value});
    this.props.onChange([value]);
  };

  renderForm() {
    const {question, onChange} = this.props;
    const {defaultAnswers} = question;

    switch (question.type) {
      case 'NUMERIC':
        return (
          <Input
            type="number"
            step="any"
            placeholder="Enter the default answer"
            defaultValue={defaultAnswers[0]}
            onBlur={e => onChange([e.target.value])}
          />
        );

      case 'BOOLEAN':
        return (
          <Input
            type="select"
            value={defaultAnswers[0]}
            onChange={e => onChange([e.target.value])}>
            <option>Choose the default answer</option>
            <option value="true">Yes (True)</option>
            <option value="false">No (False)</option>
          </Input>
        );
      
      case 'TEXT':
        return (
          <React.Fragment>
            <Input
              type="select"
              value={this.state.textDefaultType}
              onChange={this.handleTextTypeChange}>
              <option value="">Choose a default answer type</option>
              <option value="SUBMITTER_USERNAME">Submitter's Username</option>
              <option value="SUBMITTER_EMAIL">Submitter's Email</option>
              <option value="CUSTOM">Custom Text</option>
            </Input>
            {this.state.textDefaultType === 'CUSTOM' && (
              <Input
                type="text"
                placeholder="Enter the default answer"
                value={this.state.customTextValue}
                onChange={this.handleCustomTextChange}
                style={{marginTop: 8}}
              />
            )}
          </React.Fragment>
        );

      default:
        throw new Error(`Unhandled default answer type: ${question.type}`)
    }
  }

  render() {
    return (
      <SubConfiguration>
        <SubConfiguration.Item>
          {this.renderForm()}
        </SubConfiguration.Item>
      </SubConfiguration>
    );
  }
}

export default DefaultAnswers;